import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseEntityData } from '../interfaces/entity-request.interface';
import { ApiServiceHolder } from '../utils/api-service-holder';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class EntityApiService {
  private readonly _api = inject(ApiService);

  getBaseDataByPk(idEntity: number): Observable<IBaseEntityData> {
    if (!Number.isFinite(idEntity) || idEntity <= 0) {
      throw new Error('Invalid idEntity passed to getBaseDataByPk: ' + idEntity);
    }
    return this._api.request(ApiServiceHolder.entityData.getBaseDataByPk(idEntity));
  }

  getCachedBaseDataByPk(idEntity: number): Observable<IBaseEntityData> {
    if (!Number.isFinite(idEntity) || idEntity <= 0) {
      throw new Error('Invalid idEntity passed to getCachedBaseDataByPk: ' + idEntity);
    }
    return this._api.requestCached(ApiServiceHolder.entityData.getBaseDataByPk(idEntity));
  }

  getLocalCachedBaseDataByPk(idEntity: number): Observable<IBaseEntityData> {
    if (!Number.isFinite(idEntity) || idEntity <= 0) {
      throw new Error('Invalid idEntity passed to getLocalCachedBaseDataByPk: ' + idEntity);
    }
    return this._api.requestLocalStorageCached(ApiServiceHolder.entityData.getBaseDataByPk(idEntity));
  }
}
